const AMAHA_SERVICING_NUMBER = "+912071171501";
const CF_SERVICING_NUMBER = "+91-9650844774";
const MANAS_HELPLINE_NUMBER = "+1-800 891 4416";

// const inSession = `Hi. I’m in back-to-back sessions right now and may take a little time to respond. Thank you for writing in. I’ll get back to you as soon as I’m able to. If you’re feeling overwhelmed, don’t wait, please reach out to our Care Team by calling ${AMAHA_SERVICING_NUMBER}. They are available between 9 am and 9 pm. Thanks for your patience, I’ll connect with you soon.`;

const outOfOffice = `Hey, I’m currently out of office and may take a little longer to respond. If it’s something time-sensitive, our Care Team is available between 9 am and 9 pm at ${AMAHA_SERVICING_NUMBER}. If you’re in distress, please don’t wait - reach out to a helpline: http://www.healthcollective.in/contact/helplines. Thank you for understanding, I’ll get back to you as soon as I can.`;

const onLeave = `Hey, I’m on leave today and may take a little longer to respond. If you’re reaching out with a thought, a reflection, or anything else, I’ll get back to you as soon as I’m able to. If you need support sooner, please reach out to our Care Team by calling ${AMAHA_SERVICING_NUMBER}. They are available between 9 am and 9 pm. Take care, I’ll be in touch when I’m back.`;

const cfOnLeave =
  "Hello, thank you for contacting me. I am currently on leave. I will respond to your message as soon as I can.";

const unwell = `Hey, I’m feeling a bit under the weather and taking a short break to recover. I might take a little longer to get back, but I’ll check in as soon as I can. The Care Team is also around if something urgent comes up. You can reach out to them at ${AMAHA_SERVICING_NUMBER}. They are available between 9 am and 9 pm. Thank you for your patience and kindness.`;

const cfUnwell = `Hi,
I have fallen ill and won't be available for sessions today. Someone from our servicing team will be in touch to help you reschedule. Apologies for the inconvenience, hope to see you soon!`;

const unavailable = `Hi, your <providerType> is no longer practicing at Amaha. We know this might feel like a big change, especially if you were hoping to connect today. You're not alone, our care team is here to support you and help you find someone who fits your needs. You can reach out to them at ${AMAHA_SERVICING_NUMBER}. They are available between 9 am and 9 pm. Your care matters deeply to us, and we’ll make sure it continues.`;

const cfOutOfOffice = `Hi, Thank you for reaching out. I am currently out of office and will respond to your message as soon as I am able to do so. If you have any booking related questions please reach out to ${CF_SERVICING_NUMBER}. If you are in active distress, please call the national Tele MANAS helpline at ${MANAS_HELPLINE_NUMBER}`;

const cfUnavailable = `Hi, Thank you for reaching out. Unfortunately, this clincian is no longer working at Children First. Please reach out to the team at ${CF_SERVICING_NUMBER} for help with choosing a new clinician.`;

// Inserts "till <endLabel>" into the auto-reply of the statuses that can expire.
const END_TIME_REPLACEMENTS = {
  "Out Of Office": {
    amaha: ["I’m currently out of office", "I’m currently out of office"],
    childrenFirst: [
      "I am currently out of office",
      "I am currently out of office",
    ],
  },
  "On Leave": {
    amaha: ["I’m on leave today", "I’m on leave"],
    childrenFirst: ["I am currently on leave", "I am currently on leave"],
  },
};

export const getAutoReplyWithEndTime = (
  status,
  providerTypeKey,
  autoReply,
  endLabel
) => {
  const replacement = END_TIME_REPLACEMENTS[status]?.[providerTypeKey];
  if (!autoReply || !endLabel || !replacement) return autoReply;
  const [search, prefix] = replacement;
  return autoReply.replace(search, `${prefix} till ${endLabel}`);
};

export const statusOptions = [
  {
    status: { value: "Available", label: "Available" },
    autoReply: null,
  },
  {
    status: { value: "In Session", label: "In Session" },
    autoReply: null,
  },
  {
    status: { value: "Out Of Office", label: "Out Of Office" },
    autoReply: {
      amaha: { value: outOfOffice, label: outOfOffice },
      childrenFirst: { value: cfOutOfOffice, label: cfOutOfOffice },
    },
  },
  {
    status: { value: "On Leave", label: "On Leave" },
    autoReply: {
      amaha: { value: onLeave, label: onLeave },
      childrenFirst: { value: cfOnLeave, label: cfOnLeave },
    },
  },
  {
    status: { value: "Unwell", label: "Unwell" },
    autoReply: {
      amaha: { value: unwell, label: unwell },
      childrenFirst: { value: cfUnwell, label: cfUnwell },
    },
  },
  {
    status: { value: "Unavailable", label: "Unavailable" },
    autoReply: {
      amaha: { value: unavailable, label: unavailable },
      childrenFirst: { value: cfUnavailable, label: cfUnavailable },
    },
  },
];
